
import {
  GET_ANALYTICS,
  GET_GOOGLE_ANALYTICS,
  GET_GOOGLE_ANALYTICS_GRAPH,
  GET_TOP_SEARCHES,
  GET_CAMPAIGNS_ANALYTICS,
  GET_TRANSACTIONS_GRAPH_DATA,
  GET_ACTIVE_CAMPAIGNS_MAP_DATA,
  GET_FAILED_URLS_DATA,
  SAVE_DASHBOARD_WIDGET,
  GET_DASHBOARD_WIDGET
} from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import { changeParamsToQuery } from './commonFn';
export class DashboardService {

  static instance;


  static getInstance() {
    if (!DashboardService.instance) {
      DashboardService.instance = new DashboardService();
    }
    return DashboardService.instance;
  }


  fetchAnalytics = async (params) => {
    let newsResponse = await Api.get(`${GET_ANALYTICS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchGoogleAnalytics = async (params) => {
    let newsResponse = await Api.get(`${GET_GOOGLE_ANALYTICS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchGoogleAnalyticsGraph = async (params) => {
    let newsResponse = await Api.get(`${GET_GOOGLE_ANALYTICS_GRAPH.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchTopSearches = async (params) => {
    let newsResponse = await Api.get(`${GET_TOP_SEARCHES.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchCampaignAnalytics = async (params) => {
    let newsResponse = await Api.get(`${GET_CAMPAIGNS_ANALYTICS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchTransactionsGraphData = async (params) => {
    let newsResponse = await Api.get(`${GET_TRANSACTIONS_GRAPH_DATA.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchActivecampaignMapData = async (params) => {
    let newsResponse = await Api.get(`${GET_ACTIVE_CAMPAIGNS_MAP_DATA.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }


  fetchFailedUrlData = async (params) => {
    let newsResponse = await Api.get(`${GET_FAILED_URLS_DATA.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  saveDashboardWidget = async (params) => {
    let newsResponse = await Api.post(`${SAVE_DASHBOARD_WIDGET.URL}`, params);
    return newsResponse;
  }

  getDashboardWidget = async (params) => {
    let newsResponse = await Api.get(`${GET_DASHBOARD_WIDGET.URL}`, []);
    return newsResponse;
  }







}

